import axios, { AxiosError } from 'axios';

type ApiError = AxiosError<ApiErrorResponse>;

type ApiErrorResponse = {
  message: string;
};

const internalApi = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

internalApi.interceptors.response.use(
  response => response,
  (error: ApiError) => {
    if (error.response?.data?.message) {
      return Promise.reject(new Error(error.response.data.message));
    }

    return Promise.reject(
      new Error('An unexpected error occurred. Please try again.')
    );
  }
);

export default internalApi;
export type { ApiError };
